var _defs, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg72Ms6(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_7",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#03142a;}.cls-2{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 16,
    cy: 16,
    r: 16
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.57,9.56c-1.13-.54-3.73,2.56-5.91,6.99-.06,.13-.07,.27-.02,.41,.05,.13,.14,.24,.27,.3l3.29,1.56c.13,.06,.27,.07,.41,.02,.13-.05,.24-.15,.3-.28,2.05-4.49,2.8-8.46,1.67-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.42,21.71l-.46,.44c-.06,.06-.08,.14-.05,.22,.03,.08,.11,.13,.19,.13h4.25c-.04-.13-.02-.28,.04-.4l.21-.44h-4.04c-.05,0-.1,.02-.14,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.64,20.96s-.06-.02-.09-.02c-.08,0-.15,.04-.18,.12l-.58,1.23s-.02,.1,0,.15c.03,.04,.08,.07,.13,.07h1.17c.06-.01,.11-.04,.14-.1l.36-.76s.03-.1,0-.15c-.02-.05-.06-.09-.1-.11l-.86-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.71,19.18l-2.98-1.36c-.24-.11-.51,0-.62,.23-.07,.14-.09,.3-.08,.46l.14,1.35c.02,.18,.13,.34,.3,.42l1.59,.73c.18,.08,.38,.06,.54-.06l1.22-.96c.13-.1,.2-.27,.18-.43-.02-.16-.12-.31-.27-.38Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg72Ms6);
export default __webpack_public_path__ + "static/media/72-ms-6.29930161b025c8c7cdfb1c0467a91773.svg";
export { ForwardRef as ReactComponent };